import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FlowQueryModel, UserQueryModel } from "src/app/models/flowquerymodel";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import {
  UserCalendarConflictService,
  UserCalendarProviderChoice,
} from "src/app/Services/user-calendar-conflict.service";
import { CalendarLinkService } from "src/app/Services/calendar-link.service";
import { getConsultationStartEnd } from "src/app/utils/consultation-calendar.util";
import { environment } from "src/environments/environment";
import { TokenService } from "src/app/Services/token.service";

@Component({
  selector: "app-bookconsultations",
  templateUrl: "./bookconsultations.component.html",
  styleUrls: ["./bookconsultations.component.scss"],
})
export class BookconsultationsComponent implements OnInit {
  /**
   * When false, we do not OAuth or call the busy API; users verify availability in their own calendar
   * (same idea as Add to calendar after booking). Set true to restore the previous conflict-check flow.
   */
  private static readonly CALENDAR_API_CONFLICT_CHECK_ENABLED = false;
  flowData: any;
  userData: any;
  noResultReturned: boolean = false;
  pricePerSlot: any;
  selectedSlot: any = null; // To store the selected slot
  selectedDate: Date | null = null; // To store the selected date
  selectedSlotDuration: any = null; // Selected duration
  selectedTime: string | null = null; // Selected time
  /** All candidate start times in the availability window; booked ones stay visible but disabled */
  timeGridSlots: { time: string; booked: boolean }[] = [];
  /** How many time chips to show per “page” (prev/next) */
  readonly timeSlotsPageSize = 8;
  /** Start index into timeGridSlots for the current page */
  timeSlotsPageStart = 0;
  userDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    reason: "",
  };

  /** Monday-based week shown in the date strip */
  weekDates: Date[] = [];
  displayWeekStart: Date = new Date();
  availabilityLoading = false;
  fileUploading = false;
  bookingSubmitting = false;
  otherUserData: {
    emailAddress: any;
    /** Used by checkout as ContentId (flow/user row key). */
    rowKey?: any;
    type: string;
    price: any;
    title: string;
    /** JSON string of book-consultation payload; sent after paid checkout for type Consult. */
    consultationPayload?: string;
  };
  consultationStartTimeAvailiblity: any;
  consultationEndTimeAvailiblity: any;
  consultationTimeZone: any;
  userConsultationTimeZone: any;

  consultationAvailiblity: string; // Example value
  consultationCustomWeekDays: string[] = []; // Example for weekly
  consultationMonthDay: number | null = null; // Day of the month
  consultationOneDayDate: Date | null = null; // Specific one-day date
  preferredMeetPlatform: string | null = null; // Selected platform

  meetingOptions: { label: string; value: string }[] = [];
  consultationPlatformName: string;
  consultationMeetingLink: string;
  preferedMeetPlatform: any;

  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;

    const today = new Date(); // Get today's date
    today.setHours(0, 0, 0, 0); // Set the time to midnight for accurate comparison

    // Ensure the selected date is not in the past
    if (date < today) {
      return false;
    }

    const day = date.getDay(); // Get day of the week (0 = Sunday, 6 = Saturday)

    switch (this.consultationAvailiblity) {
      case "Mon-Fri":
        // Allow only Monday to Friday
        return day >= 1 && day <= 5;

      case "EveryDay":
        // Allow all dates
        return true;

      case "Weekly":
        // Allow only specific weekdays
        const weekdaysMap: { [key: string]: number } = {
          Sunday: 0,
          Monday: 1,
          Tuesday: 2,
          Wednesday: 3,
          Thursday: 4,
          Friday: 5,
          Saturday: 6,
        };
        return this.consultationCustomWeekDays.some(
          (customDay) => weekdaysMap[customDay] === day
        );

      case "Monthly":
        // Allow only the specified day of the month
        return this.consultationMonthDay
          ? date.getDate() === this.consultationMonthDay
          : false;

      case "One Day":
        // Allow only the specific one-day date
        return (
          this.consultationOneDayDate &&
          date.toDateString() ===
            new Date(this.consultationOneDayDate).toDateString()
        );

      default:
        return true;
    }
  };
  enablePaidConsult: any;
  creatorUserConsultation: any;
  /** Host (creator) username from ViewOtherUserProfile — used when flow/localStorage only had email. */
  private hostProfileUserName: string | null = null;
  showImage: boolean;
  Url: string;
  SelectedTimeSlots: any[] = [];
  slotDebug = {
    show: true,
    rawBookedCount: 0,
    scopedBookedCount: 0,
    blockedParsedCount: 0,
    generatedCount: 0,
    finalCount: 0,
    interval: 0,
    startRaw: "",
    endRaw: "",
    startMinutes: NaN,
    endMinutes: NaN,
    normalizedStartMinutes: NaN,
    normalizedEndMinutes: NaN,
  };

  /** User picks which calendar to use for optional conflict check. */
  calendarCheckProvider: UserCalendarProviderChoice = "none";
  calendarConflict = false;
  /** After "Continue anyway", suppress warning until slot/date changes. */
  calendarConflictContinueAnyway = false;
  calendarCheckPending = false;
  private calendarCheckDebounceTimer: ReturnType<typeof setTimeout> | null =
    null;
  /** Calendar provider + connect UI lives in a modal. */
  showUserCalendarModal = false;
  /** Ask first whether user wants manual conflict check. */
  showManualCalendarCheckPromptModal = false;
  /** Manual calendar reminder modal shown after selecting a time slot. */
  showManualCalendarCheckModal = false;
  oauthConfigLoaded = false;
  calendarProviderConfigured: { google: boolean; microsoft: boolean } = {
    google: true,
    microsoft: true,
  };

  ngOnInit(): void {
    this.flowData = JSON.parse(localStorage.getItem("flowData"));
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.creatorUserConsultation = JSON.parse(
      localStorage.getItem("CreatorUserConsultation")
    );
    this.userDetails.email = this.userData.emailAddress;
    this.userDetails.phone = this.userData.phoneNumber;
    this.userDetails.firstName = this.formatUsernameWithSingleAt(
      this.userData?.userName || this.userData?.firstName || ""
    );
    console.log(this.flowData);
    console.log(this.userData);
    this.displayWeekStart = this.startOfMonday(new Date());
    this.refreshWeekDates();
    if (BookconsultationsComponent.CALENDAR_API_CONFLICT_CHECK_ENABLED) {
      const linked = this.userCalendarConflictService.getConnection();
      if (linked) {
        this.calendarCheckProvider = linked.provider;
      }
      this.loadUserCalendarOAuthConfig();
      this.consumeCalendarOAuthReturnParams();
    }
    this.viewUserProfile();
  }

  get userCalendarFeatureEnabled(): boolean {
    return !!environment.userCalendar?.enabled;
  }

  get calendarProviderLabel(): string {
    switch (this.calendarCheckProvider) {
      case "google":
        return "Google Calendar";
      case "microsoft":
        return "Outlook Calendar";
      default:
        return "";
    }
  }

  get isCalendarConnectedForCurrentChoice(): boolean {
    if (this.calendarCheckProvider === "none") {
      return false;
    }
    return this.userCalendarConflictService.isConnected(
      this.calendarCheckProvider
    );
  }

  get isCurrentCalendarProviderConfigured(): boolean {
    if (this.calendarCheckProvider === "google") {
      return this.calendarProviderConfigured.google;
    }
    if (this.calendarCheckProvider === "microsoft") {
      return this.calendarProviderConfigured.microsoft;
    }
    return true;
  }

  /** One-line status next to the “open modal” control. */
  get userCalendarStatusShort(): string {
    if (this.calendarCheckProvider === "none") {
      return "Off";
    }
    const connected = this.isCalendarConnectedForCurrentChoice;
    if (this.calendarCheckProvider === "google") {
      return connected ? "Google Calendar · connected" : "Google Calendar · sign in required";
    }
    return connected
      ? "Outlook Calendar · connected"
      : "Outlook Calendar · sign in required";
  }

  openUserCalendarModal(): void {
    this.showUserCalendarModal = true;
  }

  closeUserCalendarModal(): void {
    this.showUserCalendarModal = false;
  }

  openManualCalendarCheckModal(): void {
    this.showManualCalendarCheckModal = true;
  }

  closeManualCalendarCheckModal(): void {
    this.showManualCalendarCheckModal = false;
  }

  openManualCalendarCheckPromptModal(): void {
    this.showManualCalendarCheckPromptModal = true;
  }

  closeManualCalendarCheckPromptModal(): void {
    this.showManualCalendarCheckPromptModal = false;
  }

  chooseManualConflictCheck(wantsCheck: boolean): void {
    this.closeManualCalendarCheckPromptModal();
    if (wantsCheck) {
      this.openManualCalendarCheckModal();
    }
  }

  onCalendarProviderChange(): void {
    this.resetUserCalendarConflictUi();
  }

  connectUserCalendar(): void {
    if (
      this.calendarCheckProvider !== "google" &&
      this.calendarCheckProvider !== "microsoft"
    ) {
      return;
    }
    if (!this.isCurrentCalendarProviderConfigured) {
      this.toast.warning(
        "Calendar sign-in is unavailable for this provider right now."
      );
      return;
    }
    const pathOnly = this.router.url.split("?")[0] || "/bookconsultation";
    const returnUrl = `${window.location.origin}${pathOnly}`;
    const token = this.tokenService.getToken();
    window.location.href = this.userCalendarConflictService.getOAuthStartUrl(
      this.calendarCheckProvider,
      returnUrl,
      token
    );
  }

  private loadUserCalendarOAuthConfig(): void {
    if (!this.userCalendarFeatureEnabled) {
      return;
    }
    this.userCalendarConflictService.getOAuthConfig().subscribe((cfg) => {
      this.oauthConfigLoaded = true;
      this.calendarProviderConfigured.google = !!cfg.googleConfigured;
      this.calendarProviderConfigured.microsoft = !!cfg.microsoftConfigured;
      if (
        this.calendarCheckProvider === "google" &&
        !this.calendarProviderConfigured.google
      ) {
        this.calendarCheckProvider = "none";
      } else if (
        this.calendarCheckProvider === "microsoft" &&
        !this.calendarProviderConfigured.microsoft
      ) {
        this.calendarCheckProvider = "none";
      }
    });
  }

  disconnectUserCalendar(): void {
    this.userCalendarConflictService.disconnect();
    this.resetUserCalendarConflictUi();
    this.toast.info("Calendar disconnected.");
  }

  dismissCalendarConflictChangeTime(): void {
    this.calendarConflict = false;
    this.calendarConflictContinueAnyway = false;
    this.selectedTime = null;
  }

  acknowledgeCalendarConflictContinue(): void {
    this.calendarConflict = false;
    this.calendarConflictContinueAnyway = true;
  }

  private consumeCalendarOAuthReturnParams(): void {
    const q = this.route.snapshot.queryParamMap;
    const oauthErr = q.get("calendar_oauth_error");
    if (oauthErr) {
      if (oauthErr === "not_configured") {
        this.toast.warning(
          "Calendar sign-in is temporarily unavailable. Please ask admin to configure Google/Microsoft OAuth credentials."
        );
      } else if (oauthErr === "access_denied") {
        this.toast.info("Calendar access was not granted.");
      } else {
        this.toast.error(`Could not connect calendar (${oauthErr}).`);
      }
      this.showUserCalendarModal = true;
      this.router.navigate(["/bookconsultation"], { replaceUrl: true });
      return;
    }
    if (q.get("calendar_connected") !== "1") {
      return;
    }
    const p = q.get("calendar_provider");
    if (p === "google" || p === "microsoft") {
      this.userCalendarConflictService.markConnected(p);
      this.calendarCheckProvider = p;
      this.toast.success(`${this.calendarProviderLabel} connected.`);
      this.showUserCalendarModal = true;
    }
    this.router.navigate(["/bookconsultation"], { replaceUrl: true });
  }

  private resetUserCalendarConflictUi(): void {
    this.calendarConflict = false;
    this.calendarConflictContinueAnyway = false;
    this.calendarCheckPending = false;
    if (this.calendarCheckDebounceTimer) {
      clearTimeout(this.calendarCheckDebounceTimer);
      this.calendarCheckDebounceTimer = null;
    }
  }

  private queueUserCalendarCheck(): void {
    if (!BookconsultationsComponent.CALENDAR_API_CONFLICT_CHECK_ENABLED) {
      return;
    }
    if (!this.userCalendarFeatureEnabled) {
      return;
    }
    if (this.calendarCheckProvider === "none") {
      return;
    }
    if (
      !this.userCalendarConflictService.isConnected(
        this.calendarCheckProvider
      )
    ) {
      return;
    }
    if (!this.selectedSlot || !this.selectedDate || !this.selectedTime) {
      return;
    }
    if (this.calendarCheckDebounceTimer) {
      clearTimeout(this.calendarCheckDebounceTimer);
    }
    this.calendarCheckDebounceTimer = setTimeout(() => {
      this.calendarCheckDebounceTimer = null;
      this.runUserCalendarCheck();
    }, 450);
  }

  private runUserCalendarCheck(): void {
    if (this.calendarConflictContinueAnyway) {
      return;
    }
    const provider = this.calendarCheckProvider;
    if (provider !== "google" && provider !== "microsoft") {
      return;
    }
    const range = getConsultationStartEnd({
      selectedDate: this.selectedDate,
      selectedTime: this.selectedTime,
      selectedTimeSlot: this.selectedSlot?.slotTime,
    });
    if (!range) {
      return;
    }
    this.calendarCheckPending = true;
    this.userCalendarConflictService
      .checkFreeBusy(
        provider,
        range.start.toISOString(),
        range.end.toISOString()
      )
      .subscribe({
        next: (r) => {
          this.calendarCheckPending = false;
          if (r.skipped) {
            return;
          }
          if (r.busy) {
            this.calendarConflict = true;
          } else {
            this.calendarConflict = false;
          }
        },
        error: () => {
          this.calendarCheckPending = false;
        },
      });
  }

  private formatUsernameWithSingleAt(rawName: string): string {
    const cleaned = String(rawName || "").trim().replace(/^@+/, "");
    return cleaned ? `@${cleaned}` : "";
  }

  private stripLeadingAt(rawName: string): string {
    return String(rawName || "").trim().replace(/^@+/, "");
  }

  /**
   * Public handle from API payloads: CustomerModel / view-profile `userData`, FlowModel, BundleModel — all expose `UserName` (JSON: userName).
   */
  private profileUserNameFrom(source: any): string {
    if (source == null || typeof source !== "object") {
      return "";
    }
    const raw = source.userName ?? source.UserName;
    return this.stripLeadingAt(String(raw ?? "").trim());
  }

  get creatorDisplayName(): string {
    const fromFlow =
      this.profileUserNameFrom(this.flowData) ||
      this.flowData?.firstName ||
      this.flowData?.FirstName;
    const fromConsult =
      this.profileUserNameFrom(this.creatorUserConsultation) ||
      this.creatorUserConsultation?.firstName ||
      this.creatorUserConsultation?.FirstName;
    const fromEmail =
      this.flowData?.customerEmail ||
      this.flowData?.CustomerEmail ||
      this.creatorUserConsultation?.partitionKey ||
      "";
    return fromFlow || fromConsult || fromEmail || "";
  }

  get flowTitle(): string {
    return this.flowData?.title || "";
  }

  get creatorInitials(): string {
    const n = this.creatorDisplayName.trim();
    if (!n) return "?";
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return n.substring(0, 2).toUpperCase();
  }

  get creatorProfileImageUrl(): string {
    const raw =
      this.flowData?.profilePic ||
      this.flowData?.profilePicUrl ||
      this.flowData?.ProfilePicUrl ||
      this.flowData?.creatorProfilePicUrl ||
      this.flowData?.CreatorProfilePicUrl ||
      this.creatorUserConsultation?.profilePic ||
      this.creatorUserConsultation?.profilePicUrl ||
      this.creatorUserConsultation?.ProfilePicUrl ||
      this.creatorUserConsultation?.creatorProfilePicUrl ||
      this.creatorUserConsultation?.CreatorProfilePicUrl ||
      "";
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw)) {
      return raw;
    }
    return `${environment.imageStorageBaseUrl}${raw}`;
  }

  private get bookingCreatorEmail(): string {
    return (
      this.flowData?.customerEmail ||
      this.flowData?.CustomerEmail ||
      this.creatorUserConsultation?.emailAddress ||
      this.creatorUserConsultation?.EmailAddress ||
      this.creatorUserConsultation?.partitionKey ||
      ""
    );
  }

  private get bookingCreatorUserName(): string {
    return (
      this.profileUserNameFrom(this.flowData) ||
      this.profileUserNameFrom(this.creatorUserConsultation) ||
      ""
    );
  }

  /** Customer (booker) handle for API — LoggedInUser is CustomerModel (`userName`); form mirrors that. */
  private resolvePayloadCustomerUserName(): string {
    const fromField = this.stripLeadingAt(this.userDetails.firstName);
    if (fromField) {
      return fromField;
    }
    const fromSession = this.profileUserNameFrom(this.userData);
    if (fromSession) {
      return fromSession;
    }
    return this.stripLeadingAt(
      String(this.userData?.firstName || this.userData?.FirstName || "")
    );
  }

  /** Creator handle: viewUserProfile `userData.userName`, then Flow/Bundle `userName`, then profile-only `userData`. */
  private resolvePayloadCreatorUserName(): string {
    const creatorEmail = String(this.bookingCreatorEmail || "").toLowerCase();

    const acceptHandle = (raw: string): string => {
      const s = this.stripLeadingAt(String(raw || "").trim());
      if (!s) {
        return "";
      }
      if (creatorEmail && s.toLowerCase() === creatorEmail) {
        return "";
      }
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) {
        return "";
      }
      return s;
    };

    const ordered = [
      acceptHandle(this.hostProfileUserName || ""),
      acceptHandle(this.profileUserNameFrom(this.flowData)),
      acceptHandle(this.profileUserNameFrom(this.creatorUserConsultation)),
      acceptHandle(
        String(
          this.flowData?.firstName ||
            this.flowData?.FirstName ||
            this.creatorUserConsultation?.firstName ||
            this.creatorUserConsultation?.FirstName ||
            ""
        )
      ),
    ];
    for (const v of ordered) {
      if (v) {
        return v;
      }
    }
    return acceptHandle(this.bookingCreatorUserName);
  }

  get weekRangeLabel(): string {
    if (!this.weekDates?.length) return "";
    const a = this.weekDates[0];
    const b = this.weekDates[6];
    const y = a.getFullYear();
    if (a.getMonth() === b.getMonth()) {
      return `${a.toLocaleDateString("en-GB", {
        month: "short",
        day: "numeric",
      })} – ${b.getDate()}, ${y}`;
    }
    return `${a.toLocaleDateString("en-GB", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })} – ${b.toLocaleDateString("en-GB", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })}`;
  }

  get meetingLabelSelected(): string {
    if (!this.preferredMeetPlatform) return "";
    const o = this.meetingOptions.find(
      (x) => x.value === this.preferredMeetPlatform
    );
    return o ? o.label : "";
  }
  constructor(
    private userserviceService: UserserviceService,
    private flowservices: FlowServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private http: HttpClient,
    private userCalendarConflictService: UserCalendarConflictService,
    private tokenService: TokenService,
    private calendarLinkService: CalendarLinkService
  ) {}

  canSubmit(): boolean {
    const platformOk =
      this.meetingOptions.length === 0 || !!this.preferredMeetPlatform;
    return !!(
      platformOk &&
      this.selectedSlot &&
      this.isPriceSlotEnabled(this.selectedSlot) &&
      this.selectedDate &&
      this.selectedTime &&
      this.userDetails.firstName &&
      this.userDetails.email &&
      this.userDetails.reason
    );
  }

  /** Consultation settings mark inactive slot-prices with isActive === false */
  isPriceSlotEnabled(slot: any): boolean {
    if (!slot) return false;
    return slot.isActive !== false;
  }

  hasAnyActivePriceSlot(): boolean {
    return (this.pricePerSlot || []).some((s) => this.isPriceSlotEnabled(s));
  }

  /** Numeric price for the selected slot; 0 or invalid means no payment step. */
  private selectedConsultPriceNumber(): number {
    const price = this.selectedSlot?.price;
    if (price === null || price === undefined) return 0;
    const n =
      typeof price === "number"
        ? price
        : parseFloat(String(price).replace(/[^0-9.]/g, ""));
    return isNaN(n) ? 0 : n;
  }

  submitDetails() {
    if (this.bookingSubmitting || !this.canSubmit()) {
      return;
    }
    this.bookingSubmitting = true;

    const payload = {
      ContentId:
        this.flowData != null || undefined
          ? this.flowData.rowKey
          : this.creatorUserConsultation.rowKey,
      EmailAddress:
        this.flowData != null || undefined
          ? this.flowData.customerEmail
          : this.creatorUserConsultation.partitionKey,
      ContentTitle:
        this.flowData != null
          ? this.flowData.title
          : this.creatorUserConsultation.userName,
      CustomerUserName: this.resolvePayloadCustomerUserName(),
      CreatorUserName: this.resolvePayloadCreatorUserName(),
      ConsultType: this.flowData != null || undefined ? "Flow" : "User",
      ConsultImageUrl: this.Url,
      CustomerEmailAddress: this.userDetails.email,
      CustomerPhoneNumber: this.userDetails.phone,
      SelectedTimeSlot: this.selectedSlot.slotTime,
      SelectedTimeZone: this.consultationTimeZone,
      ReasonForConsultation: this.userDetails.reason,
      PreferedTimeSlot: this.selectedSlot.slotTime,
      AmountPaid: this.selectedSlot.price,
      SelectedDate: this.selectedDate,
      SelectedTime: this.selectedTime,
      PreferedMeetPlatform: this.preferredMeetPlatform,
      IsActive: true,
      IsPaid: false,
      AgreeToTNC: true,
      Status: "Scheduled",
    };

    console.log("Payload:", payload);
    console.log("Paid:", this.enablePaidConsult);

    if (this.enablePaidConsult && this.selectedConsultPriceNumber() > 0) {
      const creatorLabel =
        this.resolvePayloadCreatorUserName() ||
        this.creatorDisplayName ||
        "host";
      this.otherUserData = {
        emailAddress: this.userData.emailAddress,
        rowKey: payload.ContentId,
        type: "Consult",
        price: this.selectedSlot.price,
        title: "Book Consultation with " + creatorLabel,
        consultationPayload: JSON.stringify(payload),
      };
      localStorage.setItem("checkoutFlow", JSON.stringify(this.otherUserData));
      this.router.navigate(["/checkout"]);
      return;
    }

    this.flowservices.bookConsultation(payload).subscribe({
      next: (data) => {
        console.log(data);
        if (data != null) {
          try {
            const rk = data?.rowKey ?? data?.RowKey;
            const pending = {
              ...payload,
              ...(rk ? { rowKey: rk } : {}),
            };
            sessionStorage.setItem(
              "pendingCalendarConsult",
              JSON.stringify(pending)
            );
          } catch {
            /* ignore */
          }
          this.toast.success("Consultation booking is completed");
          this.router.navigate(["/user-dashboard/my-consultation"]);
          return;
        }
        this.bookingSubmitting = false;
      },
      error: () => {
        this.bookingSubmitting = false;
        this.toast.error("Could not complete booking. Please try again.");
      },
    });
  }

  isStepCoverPageURISet: boolean;
  fileName: string;
  fileData: File = null;

  selectFiles(event) {
    if (event.target.files) {
      this.fileUploading = true;
      //
      this.fileData = <File>event.target.files[0];
      const formData = new FormData();
      formData.append("fileData", this.fileData);
      this.fileName = this.fileData.name;
      this.isStepCoverPageURISet = true;
      if (
        this.fileData.name.includes("JPEG") ||
        this.fileData.name.includes("jpeg") ||
        this.fileData.name.includes("png") ||
        this.fileData.name.includes("jpg") ||
        this.fileData.name.includes("PNG") ||
        this.fileData.name.includes("JFIF") ||
        this.fileData.name.includes("jfif") ||
        this.fileData.name.includes("TIFF") ||
        this.fileData.name.includes("tiff") ||
        this.fileData.name.includes("TIF") ||
        this.fileData.name.includes("tif") ||
        this.fileData.name.includes("JPG")
      ) {
        this.http
          .post(environment.apiBaseUrl + environment.uploadImageUrl, formData)
          .subscribe({
            next: (data) => {
            var mediaUploadStatus = data as any;
            this.showImage = true;
            this.fileUploading = false;
            console.log(data);
            if (mediaUploadStatus != null) {
              this.Url =
                environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
            } else {
              alert(mediaUploadStatus.message);
            }
          },
          error: () => {
            this.fileUploading = false;
          },
        });
      } else {
        this.fileUploading = false;
      }
    }
  }
  // Triggered when a slot is selected
  onSlotChange(slot: any): void {
    if (!this.isPriceSlotEnabled(slot)) {
      return;
    }
    this.selectedSlot = slot;
    this.closeManualCalendarCheckPromptModal();
    this.closeManualCalendarCheckModal();
    this.resetUserCalendarConflictUi();
    this.resetSelections();
    this.displayWeekStart = this.startOfMonday(new Date());
    this.refreshWeekDates();
  }

  startOfMonday(d: Date): Date {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    const day = x.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    x.setDate(x.getDate() + diff);
    return x;
  }

  refreshWeekDates(): void {
    const monday = this.startOfMonday(this.displayWeekStart);
    this.displayWeekStart = monday;
    this.weekDates = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(monday);
      day.setDate(monday.getDate() + i);
      this.weekDates.push(day);
    }
  }

  shiftWeek(delta: number): void {
    const monday = new Date(this.displayWeekStart);
    monday.setDate(monday.getDate() + delta * 7);
    const earliest = this.startOfMonday(new Date());
    if (monday.getTime() < earliest.getTime()) {
      return;
    }
    this.displayWeekStart = monday;
    this.refreshWeekDates();
  }

  canShiftWeekBack(): boolean {
    const earliest = this.startOfMonday(new Date());
    return this.displayWeekStart.getTime() > earliest.getTime();
  }

  pickDate(d: Date): void {
    if (this.isDateStripDisabled(d)) {
      return;
    }
    this.closeManualCalendarCheckPromptModal();
    this.closeManualCalendarCheckModal();
    this.resetUserCalendarConflictUi();
    this.selectedDate = new Date(d);
    this.onDateChange();
  }

  isDateStripDisabled(d: Date): boolean {
    return !this.dateFilter(d);
  }

  isSameCalendarDay(a: Date, b: Date): boolean {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  formatWeekdayShort(d: Date): string {
    return d.toLocaleDateString("en-GB", { weekday: "short" });
  }

  formatTimeDisplay(hhmm: string): string {
    if (!hhmm) {
      return "";
    }
    const parts = hhmm.split(":").map(Number);
    const h = parts[0];
    const m = parts[1] ?? 0;
    const dt = new Date();
    dt.setHours(h, m, 0, 0);
    return dt.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  formatMoney(price: any): string {
    if (price === null || price === undefined) {
      return "£—";
    }
    const n =
      typeof price === "number"
        ? price
        : parseFloat(String(price).replace(/[^0-9.]/g, ""));
    if (isNaN(n)) {
      return `£${price}`;
    }
    return `£${n.toFixed(2)}`;
  }

  selectTime(slot: { time: string; booked: boolean }): void {
    if (slot.booked || this.isPastTimeForSelectedDate(slot.time)) {
      return;
    }
    this.calendarConflictContinueAnyway = false;
    this.selectedTime = slot.time;
    if (!BookconsultationsComponent.CALENDAR_API_CONFLICT_CHECK_ENABLED) {
      this.openManualCalendarCheckPromptModal();
    }
    if (BookconsultationsComponent.CALENDAR_API_CONFLICT_CHECK_ENABLED) {
      this.queueUserCalendarCheck();
      if (this.userCalendarFeatureEnabled) {
        this.openUserCalendarModal();
      }
    }
  }

  /** Opens Google Calendar day view for the **selected** local day (not “today” unless that’s what you picked). */
  openGoogleCalendarDayView(): void {
    if (!this.selectedDate) {
      return;
    }
    this.calendarLinkService.openGoogleCalendarDayView(this.selectedDate);
  }

  /** Opens Outlook on the web day view for the selected local date. */
  openOutlookCalendarDayView(): void {
    if (!this.selectedDate) {
      return;
    }
    this.calendarLinkService.openOutlookWebCalendarDayView(this.selectedDate);
  }

  /**
   * Apple Calendar and other apps: download .ics for the selected day, or the exact slot if time + duration are set.
   */
  downloadSlotCheckIcs(): void {
    if (!this.selectedDate) {
      return;
    }
    const range =
      this.selectedTime && this.selectedSlot
        ? getConsultationStartEnd({
            selectedDate: this.selectedDate,
            selectedTime: this.selectedTime,
            selectedTimeSlot: this.selectedSlot.slotTime,
          })
        : null;
    this.calendarLinkService.downloadAvailabilityCheckIcs({
      date: this.selectedDate,
      start: range?.start,
      end: range?.end,
      title: range
        ? "Verify Flowchest time slot"
        : "Check calendar — Flowchest booking day",
      details: range
        ? "Compare this time with your calendar before you complete the booking."
        : "All-day placeholder for the day you chose—open it in Apple Calendar or another app to review your schedule.",
    });
  }

  isTimeSlotDisabled(slot: { time: string; booked: boolean }): boolean {
    return slot.booked || this.isPastTimeForSelectedDate(slot.time);
  }

  hasAnySelectableTimeSlot(): boolean {
    return this.timeGridSlots.some((s) => !this.isTimeSlotDisabled(s));
  }

  get visibleTimeGridSlots(): { time: string; booked: boolean }[] {
    return this.timeGridSlots.slice(
      this.timeSlotsPageStart,
      this.timeSlotsPageStart + this.timeSlotsPageSize
    );
  }

  get timeSlotsPagingNeeded(): boolean {
    return this.timeGridSlots.length > this.timeSlotsPageSize;
  }

  get timeSlotsPageLabel(): string {
    if (this.timeGridSlots.length === 0) {
      return "";
    }
    const from = this.timeSlotsPageStart + 1;
    const to = Math.min(
      this.timeSlotsPageStart + this.timeSlotsPageSize,
      this.timeGridSlots.length
    );
    return `${from}–${to} of ${this.timeGridSlots.length}`;
  }

  private get timeSlotsMaxPageStart(): number {
    const n = this.timeGridSlots.length;
    if (n <= this.timeSlotsPageSize) {
      return 0;
    }
    return Math.floor((n - 1) / this.timeSlotsPageSize) * this.timeSlotsPageSize;
  }

  shiftTimeSlotsPage(delta: number): void {
    const next =
      this.timeSlotsPageStart + delta * this.timeSlotsPageSize;
    const maxStart = this.timeSlotsMaxPageStart;
    this.timeSlotsPageStart = Math.max(0, Math.min(maxStart, next));
  }

  canShiftTimeSlotsBack(): boolean {
    return this.timeSlotsPageStart > 0;
  }

  canShiftTimeSlotsForward(): boolean {
    return this.timeSlotsPageStart < this.timeSlotsMaxPageStart;
  }

  private resetTimeSlotsPage(): void {
    this.timeSlotsPageStart = 0;
  }

  private syncTimeSlotsPageAfterGenerate(): void {
    this.resetTimeSlotsPage();
    if (this.selectedTime) {
      const idx = this.timeGridSlots.findIndex((s) => s.time === this.selectedTime);
      if (idx >= 0) {
        this.timeSlotsPageStart =
          Math.floor(idx / this.timeSlotsPageSize) * this.timeSlotsPageSize;
      }
    }
  }

  isPastTimeForSelectedDate(time: string): boolean {
    if (!this.selectedDate) {
      return false;
    }
    const slotMinutes = this.timeStringToMinutes(time);
    if (isNaN(slotMinutes)) {
      return false;
    }
    const now = new Date();
    const selected = new Date(this.selectedDate);
    const isToday =
      selected.getFullYear() === now.getFullYear() &&
      selected.getMonth() === now.getMonth() &&
      selected.getDate() === now.getDate();
    if (!isToday) {
      return false;
    }
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    return slotMinutes <= nowMinutes;
  }

  trackByWeekDate(index: number, d: Date): number {
    return d.getTime();
  }

  trackByTimeStr(index: number, t: string): string {
    return t;
  }

  trackByTimeGridSlot(index: number, slot: { time: string; booked: boolean }): string {
    return slot.time;
  }

  trackBySlot(index: number, slot: any): string {
    if (!slot) return String(index);
    return `${slot.slotTime}-${slot.price}-${index}`;
  }

  isSameSlot(a: any, b: any): boolean {
    if (!a || !b) return false;
    return a.slotTime === b.slotTime && a.price === b.price;
  }

  // Triggered when a date is selected
  onDateChange(): void {
    if (this.selectedDate != null) {
      this.selectedDate = new Date(
        this.selectedDate.toLocaleDateString("en-CA").split("T")[0]
      ); // Extract YYYY-MM-DD
    }
    this.timeGridSlots = [];
    this.resetTimeSlotsPage();
    this.GetAllBookedDated();
    // if (this.selectedSlot) {
    //   console.log(this.SelectedTimeSlots);
    //   this.generateAvailableTimes();
    // }
  }

  // Resets time and available times
  resetSelections(): void {
    this.selectedDate = null;
    this.selectedTime = null;
    this.timeGridSlots = [];
    this.resetTimeSlotsPage();
    this.resetUserCalendarConflictUi();
  }
  timeStringToMinutes(time: string): number {
    if (!time) return NaN;
    const raw = String(time).trim().toLowerCase();
    const embedded = raw.match(/(\d{1,2}):(\d{2})(?::\d{2})?\s*(am|pm)?/i);
    const candidate = embedded ? embedded[0] : raw;

    // Supports:
    // - "09:30"
    // - "09:30:00"
    // - "9:30 am"
    // - "09:30 PM"
    const match = candidate.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(am|pm)?$/i);
    if (!match) return NaN;

    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const meridiem = (match[3] || "").toLowerCase();

    if (minutes < 0 || minutes > 59 || hours < 0 || hours > 23) return NaN;

    if (meridiem) {
      if (hours < 1 || hours > 12) return NaN;
      if (meridiem === "am") {
        hours = hours === 12 ? 0 : hours;
      } else {
        hours = hours === 12 ? 12 : hours + 12;
      }
    }

    return hours * 60 + minutes;
  }

  GetAllBookedDated(): void {
    let timeSlotByTime: Array<{ startMinutes: number; endMinutes: number }> =
      [];
    this.availabilityLoading = true;

    const flowQueryModel = new FlowQueryModel();
    flowQueryModel.SearchDateTime = this.selectedDate;
    flowQueryModel.otherUserEmail = this.bookingCreatorEmail;

    console.log(flowQueryModel);
    this.flowservices
      .getConsultationByDate(flowQueryModel)
      .subscribe({
        next: (data) => {
        this.slotDebug.rawBookedCount = (data || []).length;
        const scopedData = (data || []).filter((element) =>
          this.shouldBlockConsultationForAvailability(element)
        );
        this.slotDebug.scopedBookedCount = scopedData.length;
        scopedData.forEach((element) => {
          if (element.selectedTime && element.selectedTimeSlot) {
            const startMinutes = this.timeStringToMinutes(element.selectedTime);
            const duration = this.convertToMinutes(element.selectedTimeSlot);
            if (isNaN(startMinutes) || !duration || duration <= 0) {
              return;
            }
            timeSlotByTime.push({
              startMinutes,
              endMinutes: startMinutes + duration,
            });
          }
        });
        this.slotDebug.blockedParsedCount = timeSlotByTime.length;
        console.log(timeSlotByTime);
        if (this.selectedSlot) {
          this.generateAvailableTimes(timeSlotByTime);
        }
        console.log(scopedData);
        this.availabilityLoading = false;
      },
      error: () => {
        this.timeGridSlots = [];
        this.resetTimeSlotsPage();
        this.slotDebug.finalCount = 0;
        this.availabilityLoading = false;
      },
    });
  }

  generateAvailableTimes(
    timeSlotByTime: Array<{ startMinutes: number; endMinutes: number }>
  ): void {
    const interval = this.convertToMinutes(this.selectedSlot.slotTime); // Convert slot time to minutes
    let start = this.timeStringToMinutes(
      this.consultationStartTimeAvailiblity
    ); // Start time in minutes
    let end = this.timeStringToMinutes(this.consultationEndTimeAvailiblity); // End time in minutes
    this.timeGridSlots = [];
    this.slotDebug.interval = interval;
    this.slotDebug.startRaw = String(this.consultationStartTimeAvailiblity || "");
    this.slotDebug.endRaw = String(this.consultationEndTimeAvailiblity || "");
    this.slotDebug.startMinutes = start;
    this.slotDebug.endMinutes = end;
    const normalized = this.normalizeAvailabilityWindow(
      start,
      end,
      this.slotDebug.startRaw,
      this.slotDebug.endRaw
    );
    start = normalized.start;
    end = normalized.end;
    this.slotDebug.normalizedStartMinutes = start;
    this.slotDebug.normalizedEndMinutes = end;
    this.slotDebug.generatedCount = 0;
    this.slotDebug.finalCount = 0;

    // Guard against bad/unknown time formats from API.
    if (!interval || isNaN(start) || isNaN(end) || end <= start) {
      this.timeGridSlots = [];
      return;
    }

    for (let t = start; t + interval <= end; t += interval) {
      const timeStr = this.formatTime(t);
      const slotEnd = t + interval;
      let booked = false;
      for (let i = 0; i < timeSlotByTime.length; i++) {
        const b = timeSlotByTime[i];
        if (t < b.endMinutes && slotEnd > b.startMinutes) {
          booked = true;
          break;
        }
      }
      this.timeGridSlots.push({ time: timeStr, booked });
    }
    this.slotDebug.generatedCount = this.timeGridSlots.length;
    this.slotDebug.finalCount = this.timeGridSlots.filter(
      (s) => !this.isTimeSlotDisabled(s)
    ).length;

    if (this.selectedTime) {
      const row = this.timeGridSlots.find((s) => s.time === this.selectedTime);
      if (!row || this.isTimeSlotDisabled(row)) {
        this.selectedTime = null;
      }
    }

    this.syncTimeSlotsPageAfterGenerate();

    console.log("Time grid slots:", this.timeGridSlots);
  }

  private normalizeAvailabilityWindow(
    start: number,
    end: number,
    startRaw: string,
    endRaw: string
  ): { start: number; end: number } {
    if (isNaN(start) || isNaN(end)) {
      return { start, end };
    }

    if (end > start) {
      return { start, end };
    }

    const hasMeridiemStart = /am|pm/i.test(startRaw || "");
    const hasMeridiemEnd = /am|pm/i.test(endRaw || "");

    // Common backend pattern: "10:00" to "05:00" intended as 10 AM - 5 PM.
    if (!hasMeridiemStart && !hasMeridiemEnd && start < 12 && end < 12) {
      return { start, end: end + 12 * 60 };
    }

    // Fallback: treat as cross-midnight availability window.
    return { start, end: end + 24 * 60 };
  }

  /** Active bookings for this host and the current booker's other consultations block overlapping slots. */
  private shouldBlockConsultationForAvailability(entry: any): boolean {
    if (!this.consultationStatusBlocksAvailability(entry)) {
      return false;
    }
    if (this.isConsultationForLoggedInBooker(entry)) {
      return true;
    }
    return this.isConsultationForSelectedCreator(entry);
  }

  private consultationStatusBlocksAvailability(entry: any): boolean {
    const s = String(entry?.status ?? "").trim().toLowerCase();
    if (!s) return true;
    if (s === "canceled" || s === "cancelled" || s === "declined") {
      return false;
    }
    return true;
  }

  private isConsultationForLoggedInBooker(entry: any): boolean {
    const myEmail = String(this.userData?.emailAddress || "").toLowerCase();
    const cust = String(
      entry?.customerEmailAddress || entry?.CustomerEmailAddress || ""
    ).toLowerCase();
    return !!myEmail && !!cust && cust === myEmail;
  }

  private isConsultationForSelectedCreator(entry: any): boolean {
    const creatorEmail = String(this.bookingCreatorEmail || "").toLowerCase();
    const creatorUserName = String(this.bookingCreatorUserName || "").toLowerCase();
    const creatorContentId = String(
      this.flowData?.rowKey || this.creatorUserConsultation?.rowKey || ""
    ).toLowerCase();

    if (!entry) {
      return false;
    }
    if (!creatorEmail && !creatorUserName) {
      return false;
    }

    const entryCreatorEmail = String(
      entry.creatorEmailAddress ||
        entry.creatorUserEmail ||
        entry.emailAddress ||
        entry.partitionKey ||
        ""
    ).toLowerCase();
    const entryCreatorUserName = String(entry.creatorUserName || "").toLowerCase();
    const entryContentId = String(
      entry.contentId || entry.flowRowKey || entry.rowKey || ""
    ).toLowerCase();

    const emailMatches =
      !!creatorEmail && !!entryCreatorEmail && creatorEmail === entryCreatorEmail;
    const userMatches =
      !!creatorUserName &&
      !!entryCreatorUserName &&
      creatorUserName === entryCreatorUserName;
    const contentMatches =
      !!creatorContentId &&
      !!entryContentId &&
      creatorContentId === entryContentId;

    if (entryCreatorEmail || entryCreatorUserName || entryContentId) {
      return emailMatches || userMatches || contentMatches;
    }

    // If we know the selected creator but this row has no creator identity,
    // avoid blocking all slots with unrelated bookings from other users.
    return false;
  }

  // Helper function to convert duration string like "1 hrs 0 mins" or "10 mins" to minutes
  convertToMinutes(duration: string): number {
    let totalMinutes = 0;
    const regex = /(\d+)\s*(hrs?|mins?)/g;
    let match;

    // Extract hours and minutes from the duration string
    while ((match = regex.exec(duration)) !== null) {
      const value = parseInt(match[1]);
      const unit = match[2].toLowerCase();

      if (unit.startsWith("hr")) {
        totalMinutes += value * 60; // Convert hours to minutes
      } else if (unit.startsWith("min")) {
        totalMinutes += value; // Minutes are already in minutes
      }
    }

    return totalMinutes;
  }

  // Example formatTime function (you may already have this)
  formatTime(time: number): string {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`; // Format time as "HH:MM"
  }

  viewUserProfile(): void {
    //
    this.noResultReturned = true;

    const flowQueryModel = new UserQueryModel();
    flowQueryModel.userEmail = this.userData.emailAddress;
    flowQueryModel.otherUserEmail =
      this.flowData != null
        ? this.flowData.customerEmail || this.flowData.CustomerEmail
        : this.creatorUserConsultation?.emailAddress ||
          this.creatorUserConsultation?.EmailAddress ||
          this.creatorUserConsultation?.partitionKey;

    console.log(flowQueryModel);
    this.userserviceService
      .viewUserProfile(flowQueryModel)
      .subscribe((data) => {
        console.log(data);
        const ud = data?.userData;
        const hostHandle = this.profileUserNameFrom(ud);
        this.hostProfileUserName = hostHandle || null;
        this.pricePerSlot = data.userData.pricePerSlot;
        this.consultationEndTimeAvailiblity =
          data.userData.consultationEndTimeAvailiblity;
        this.consultationStartTimeAvailiblity =
          data.userData.consultationStartTimeAvailiblity;
        this.consultationTimeZone = data.userData.consultationTimeZone;
        this.consultationAvailiblity = data.userData.consultationAvailiblity;
        this.consultationCustomWeekDays =
          data.userData.consultationCustomWeekDays;
        this.consultationMonthDay = data.userData.consultationMonthDay;
        this.consultationOneDayDate = data.userData.consultationOneDayDate;
        this.consultationPlatformName =
          data.userData.consultationPlatformName ?? "";
        this.consultationMeetingLink =
          data.userData.consultationMeetingLink ??
          data.userData.consultationMeetLink ??
          data.userData.consultationZoomLink ??
          "";
        this.enablePaidConsult = data.userData.isConsultationPaid;
        console.log(this.consultationEndTimeAvailiblity);
        console.log(this.consultationStartTimeAvailiblity);
        console.log(this.consultationTimeZone);
        console.log(this.pricePerSlot);
        if (this.selectedSlot && !this.isPriceSlotEnabled(this.selectedSlot)) {
          this.selectedSlot = null;
          this.resetSelections();
        }
        this.meetingOptions = [];
        if (this.consultationMeetingLink) {
          const label =
            (this.consultationPlatformName &&
              String(this.consultationPlatformName).trim()) ||
            "Meeting link";
          this.meetingOptions.push({
            label,
            value: this.consultationMeetingLink,
          });
        }
        if (this.meetingOptions.length === 1) {
          this.preferredMeetPlatform = this.meetingOptions[0].value;
        }
        this.refreshWeekDates();
      });
    this.noResultReturned = false;
  }
  toggleTimeZone(day) {
    console.log(day);
    this.consultationTimeZone = day;
    console.log(this.consultationTimeZone);
  }
  timezones = [
    { value: "UTC-12:00", label: "UTC-12:00" },
    { value: "UTC-11:00", label: "UTC-11:00" },
    { value: "UTC-10:00", label: "UTC-10:00" },
    { value: "UTC-09:00", label: "UTC-09:00" },
    { value: "UTC-08:00", label: "UTC-08:00 (PST)" },
    { value: "UTC-07:00", label: "UTC-07:00 (MST)" },
    { value: "UTC-06:00", label: "UTC-06:00 (CST)" },
    { value: "UTC-05:00", label: "UTC-05:00 (EST)" },
    { value: "UTC-04:00", label: "UTC-04:00 (AST)" },
    { value: "UTC-03:00", label: "UTC-03:00" },
    { value: "UTC-02:00", label: "UTC-02:00" },
    { value: "UTC-01:00", label: "UTC-01:00" },
    { value: "UTC+00:00", label: "UTC+00:00 (GMT)" },
    { value: "UTC+01:00", label: "UTC+01:00 (CET)" },
    { value: "UTC+02:00", label: "UTC+02:00 (EET)" },
    { value: "UTC+03:00", label: "UTC+03:00 (MSK)" },
    { value: "UTC+04:00", label: "UTC+04:00" },
    { value: "UTC+05:00", label: "UTC+05:00" },
    { value: "UTC+05:30", label: "UTC+05:30 (IST)" },
    { value: "UTC+06:00", label: "UTC+06:00" },
    { value: "UTC+07:00", label: "UTC+07:00" },
    { value: "UTC+08:00", label: "UTC+08:00 (CST)" },
    { value: "UTC+09:00", label: "UTC+09:00 (JST)" },
    { value: "UTC+09:30", label: "UTC+09:30 (ACST)" },
    { value: "UTC+10:00", label: "UTC+10:00 (AEST)" },
    { value: "UTC+11:00", label: "UTC+11:00" },
    { value: "UTC+12:00", label: "UTC+12:00 (NZST)" },
    { value: "UTC+13:00", label: "UTC+13:00" },
    { value: "UTC+14:00", label: "UTC+14:00" },
  ];
}
